<template>
    <div v-if="type === 'dashboards'" class="d-flex flex-row dashboard-row">
        <div class="sidebars text-white border border-black flex-shrink-0">
            <div class="rotate rotate-left h5">
                Alerte
            </div>
        </div>
        <div class="flex-fill text-center p-3 text-white h2 mb-0 " :class="alertDashboardClass()" v-bind:style="alertStyle()">
            {{ alert.text }}
        </div>
        <div class="sidebars text-white border border-black flex-shrink-0">
            <div class="rotate rotate-right">
                Alerte
            </div>
        </div>
    </div>
    <div v-else class="text-center" :class="alertClass()" v-bind:style="alertStyle()">
        {{ alert.text }}
    </div>
</template>

<script>
export default {
    name: 'Alert',

    props: {
        alert: {
            type: Object,
            required: true,
        },
        type: {
            type: String,
            required: false,
        },
    },

    methods: {
        alertDashboardClass() {
            let alertClass = '';
            if(this.alert.alert_class) {
                if(this.alert.alert_class === 'light') {
                    alertClass += 'text-dark ';
                }
                alertClass += 'bg-'+this.alert.alert_class+' ';
            }
            return alertClass;
        },
        alertClass() {
            let alertClass = '';
            if(this.alert.type === 'cart') {
                alertClass += 'py-5 h2 ';
            }
            if(this.alert.image) {
                alertClass += 'lcdd-alert ';
            } else if(this.alert.alert_class) {
                alertClass += 'alert alert-'+this.alert.alert_class+' ';
            }
            return alertClass;
        },
        alertStyle() {
            let alertStyle = {};
            if(this.alert.image) {
                alertStyle['background-image'] = 'url(' + this.alert.image + ')';
            }
            return alertStyle;
        },
    },
}
</script>

<style lang="scss" scoped>
    .lcdd-alert {
        border: 1px solid #b1b1b1;
        color: #ffffff;
        text-shadow: -1px -1px 1px #000, -1px 1px 1px #000, 1px -1px 1px #000, 1px 1px 1px #000;
        background-size: cover;
        background-position: center;
    }

    .dashboard-row {
        background-color: #343a40;
        border-bottom: 4px solid #000;
        min-height: 110px;
    }

    .sidebars {
        width: 70px;
        position: relative;
        line-height: 1;
        .rotate {
            font-size: 1.125rem;
            line-height: 1;
        }
    }
</style>
